import { IconEye, IconWorldPin } from "@tabler/icons-react";
import React from "react";
import { Form, Row, Col, InputGroup, FormText } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  IconBuildings,
  IconBuildingBank,
  IconMailForward,
  IconUser,
  IconMail,
  IconPhone,
} from "@tabler/icons-react";
import { Controller } from "react-hook-form";
import { handleKeyDown } from "../../constant/_constant";

const VendorFormStep2 = ({ formData, handleFormChange, control, errors }) => {
  return (
    <>
   
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <InputGroup>
                <Controller
                  name="billing_name"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter Full Name" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                      
                    </>
                  )}
                />
              </InputGroup>
              {errors.billing_name && (
                        <span className="text-danger">
                          {errors.billing_name.message}
                        </span>
                      )}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <InputGroup>
                <Controller
                  name="billing_email"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter Email" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                    </>
                  )}
                />
              </InputGroup>
              {errors.billing_email && (
                <span className="text-danger">
                  {errors.billing_email.message}
                </span>
              )}
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconPhone stroke={1} />
                </InputGroup.Text>
                <Controller
                  name="billing_phone"
                  control={control}
                  rules={{
                    required: "Phone number is required",
                    validate: (value) =>
                      (value && value.length > 0) || "Invalid phone number",
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      className="form-control"
                      {...field}
                      defaultCountry="US"
                      countryCallingCodeEditable={false}
                      international
                      placeholder="Enter phone number"
                      onChange={field.onChange}
                    />
                  )}
                />
              </InputGroup>
              {errors.billing_phone && (
                <span className="text-danger">
                  {errors.billing_phone.message}
                </span>
              )}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Street Address 1</Form.Label>
              <InputGroup>
                <Controller
                  name="address_1"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter Address 1" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                   
                    </>
                  )}
                />
              </InputGroup>
              {errors.address_1 && (
                        <span className="text-danger">
                          {errors.address_1.message}
                        </span>
                      )}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Street Address 2</Form.Label>
              <InputGroup>
                <Controller
                  name="address_2"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter Address 2" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                     
                    </>
                  )}
                />
              </InputGroup>
              {errors.address_2 && (
                        <span className="text-danger">
                          {errors.address_2.message}
                        </span>
                      )}
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <InputGroup>
                <Controller
                  name="city"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter City Name" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                   
                    </>
                  )}
                />
              </InputGroup>
              {errors.city && (
                        <span className="text-danger">
                          {errors.city.message}
                        </span>
                      )}
            </Form.Group>
          </Col>

          {/* <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <InputGroup>
                <Controller
                  name="city"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control {...field} placeholder="Enter City Name" />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                      {errors.city && (
                        <span className="text-danger">
                          {errors.city.message}
                        </span>
                      )}
                    </>
                  )}
                />
              </InputGroup>
            </Form.Group>
          </Col> */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <InputGroup>
                <Controller
                  name="state"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control
                        {...field}
                        placeholder="Enter Your State "
                      />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                    
                    </>
                  )}
                />
              </InputGroup>
              {errors.state && (
                        <span className="text-danger">
                          {errors.state.message}
                        </span>
                      )}
            </Form.Group>
          </Col>
        </Row>

        {/* Third Row: ZIP Code and Country */}
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>ZIP Code</Form.Label>
              <InputGroup>
                <Controller
                  name="zip_code"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control
                        {...field}
                        placeholder="Enter your area’s ZIP Code"
                      />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                     
                    </>
                  )}
                />
              </InputGroup>
              {errors.zip_code && (
                        <span className="text-danger">
                          {errors.zip_code.message}
                        </span>
                      )}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <InputGroup>
                <Controller
                  name="country"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control
                        {...field}
                        placeholder="Enter Your Country Name"
                      />
                      <InputGroup.Text>
                        <IconUser stroke={1} />
                      </InputGroup.Text>
                   
                    </>
                  )}
                />
              </InputGroup>
              {errors.country && (
                        <span className="text-danger">
                          {errors.country.message}
                        </span>
                      )}
            </Form.Group>
          </Col>
        </Row>

        {/* <div className="d-flex justify-content-end align-items-center mt-4">
          <Button variant="link">
           <IconEye /> Preview Address
          </Button>
        </div> */}
 
    </>
  );
};

export default VendorFormStep2;
